import { Slider } from '@starsoft/common/components';
import { banners } from '@/constants/banners-casino';
import { useMemo } from 'react';
import CasinoBanner from './Banner';

export default function CasinoBanners() {
  const Banners = useMemo(
    () =>
      banners.map(banner => (
        <CasinoBanner key={`casino-banner-item-${banner?.id}`} item={banner} />
      )),
    [],
  );

  return (
    <Slider size={3} useAutoScroll absoluteButton>
      {Banners}
    </Slider>
  );
}
